<template>
  <div class="w-screen max-w-sm mx-auto h-screen flex-col items-center justify-center">

    <!-- name and greeting -->
    <div class="p-4">
      <Spinner v-if="!name" />
      <div v-else :class="content && 'h4'" class="h5 text-center m-0">
        <img v-if="content" class="px-16 mt-8" src="../assets/prev-quiz-icon.svg">
        <img v-if="content" class="mb-8" src="../assets/prev-quiz-title.svg">

        <!-- quiz title -->
        <p v-if="content">Willkommen beim Quiz <br>
          <span class="text-bold"> {{ quiz.name }}</span>
        </p>

        <!-- your name -->
        <p :class="content && 'mt-4'" class="block">Dein Name ist <br>
          <span class="font-bold">{{ name }}</span>
        </p>

        <img v-if="content" class="px-8 mt-12" src="../assets/logo-sozialdienste.png">

        <!-- imprint -->
        <p v-if="content" class="mt-6 text-sm">
          <a href="https://caritas.erzbistum-koeln.de/neuss-cv/impressum/" target="_blank">Impressum</a>
        </p>
      </div>
    </div>

    <!-- answer option -->
    <div v-if="activeQuestion" class="p-4 pt-0 grid grid-cols-1 gap-4">
      <div v-for="(option, index) in activeQuestion.options"
           :class="votes[activeQuestionID] && votes[activeQuestionID].option === option && 'bg-blue-200 border-blue-200'"
           class="bg-white p-6 rounded-xl shadow-xl border-gray-100 border flex flex-row justify-between items-center text-center m-0 p-4 select-none"
           @click="vote(option)">

        <!-- number circle -->
        <span
            class="w-10 h-10 bg-gray-800 text-white font-bold text-sm flex-shrink-0 bg-white rounded-full inline-flex justify-center items-center mr-4 relative z-20">
          {{ index + 1 }}</span>

        <span class="flex-grow h5 text-left">{{ option }}</span>
      </div>
    </div>

    <div v-else-if="quiz.leaderboard">
      <p class="h5 text-center">Ergebnisse vom Quiz <br>
        <span class="text-bold"> {{ quiz.name }}</span>
      </p>

      <leaderboard :leaderboard="quiz.leaderboard" class="px-2" />
    </div>

  </div>
</template>
<script>
import { auth, db, globalSettingsDoc, quizCollection } from "../plugins/firebase";
import Spinner from "../components/Spinner";
import firebase from "firebase/app";
import Leaderboard from "../components/Leaderboard";

export default {
  components: { Leaderboard, Spinner },
  data() {
    return {
      quizid: this.$route.params.id,
      quiz: null,
      name: null,
      votes: {}
    }
  },
  async created() {
    // first create anonymous account
    await auth.signInAnonymously();

    // subscribe to quiz changes
    quizCollection.doc(this.quizid).onSnapshot(doc => {
      this.quiz = {
        id: doc.id,
        ...doc.data(),
      };
    });

    // subscribe to vote changes and store them in votes object
    quizCollection.doc(this.quizid).collection("votes").where("userid", "==", auth.currentUser.uid).onSnapshot(snapshot => {
      this.votes = {};
      snapshot.forEach(doc => {
        this.votes[doc.data().question] = doc.data();
      });
    });

    // retrieve name
    await getRandomName(this.quizid).then(name => {
      this.name = name;
    });
  },
  methods: {
    // vote for an option of the current question
    vote(option) {
      quizCollection.doc(this.quizid).collection("votes").doc(`${auth.currentUser.uid}-${this.activeQuestionID}`).set({
        name: this.name,
        userid: auth.currentUser.uid,
        question: this.activeQuestionID,
        option,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });
    }
  },
  computed: {
    activeQuestionID() {
      if (!this.quiz || this.quiz.currentQuestion == null || this.quiz.currentQuestion < 0 || !this.quiz.votingEnabled)
        return null;
      else
        return this.quiz.currentQuestion;
    },
    activeQuestion() {
      if (this.activeQuestionID == null)
        return null;
      else
        return this.quiz.questions[this.activeQuestionID];
    },
    content() {
      return !this.activeQuestion && !this.quiz.leaderboard;
    }
  }
}

async function getRandomName(quizid) {
  // check for existing name
  const query = await quizCollection.doc(quizid).collection("players").where("userid", "==", auth.currentUser.uid).get();

  if (query.docs.length > 0)
    return query.docs[0].id;

  const names = (await globalSettingsDoc.get()).data().usernames;

  return await db.runTransaction(async t => {

    for (let i = 0; i < 5; i++) {
      const tryName = names.random();
      const query = await t.get(quizCollection.doc(quizid).collection("players").doc(tryName));

      if (!query.exists) {

        // create document
        await t.set(quizCollection.doc(quizid).collection("players").doc(tryName), {
          userid: auth.currentUser.uid,
          score: 0,
          created: Date.now()
        });

        return tryName;
      }
    }

    alert("Alle Namen sind bereits vergeben, du kannst leider nicht mitspielen. ");

  })
}
</script>